import { render, staticRenderFns } from "./gestaoFerias.vue?vue&type=template&id=31f78d92&scoped=true&"
import script from "./gestaoFerias.vue?vue&type=script&lang=js&"
export * from "./gestaoFerias.vue?vue&type=script&lang=js&"
import style0 from "./gestaoFerias.vue?vue&type=style&index=0&id=31f78d92&scoped=true&lang=css&"
import style1 from "./gestaoFerias.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f78d92",
  null
  
)

export default component.exports